import {
  Checkbox,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  Typography,
  InputLabel,
  TextField,
  MenuItem,
} from "@mui/material";
import React, { useState, useEffect, Fragment } from "react";
import Input from "../../../../components/uiElements/input/Input";
import Dialog from "../../../../components/uiElements/modal";
import CancelIcon from "@mui/icons-material/Cancel";
import Button from "../../../../components/uiElements/button";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useDispatch, useSelector } from "react-redux";
import BlockIcon from "@mui/icons-material/Block";
import { setInfoAgentRecruitment } from "../../../../redux/agents/agentRecruitment/setInfoAgentRecruitment";
import { useParams } from "react-router-dom";
import ResponseAlert from "../../../../components/responseAlert";

export const EditPhoneModal = ({ closeModal,state }) => {
  const params = useParams();
  const dispatch = useDispatch();
  const [phoneNumber, setPhoneNumber] = useState([
    {
      value: "",
      type: "",
      isPrimary: false,
      bad_number: true,
      isEditable: true,
    },
  ]);

  const [errorAlert, setErrorAlert] = useState({
    errorMsg: "",
    errorType: "",
    isOpen: false,
  });

  const setPhoneNumberFunc = (param) => {
    setPhoneNumber((prev) => [...prev, param]);
  };

  const updateNumbersFunc = (param) => {
    const data = phoneNumber.filter((_, index) => index !== param);
    setPhoneNumber(data);
  };

  const {
    list: { lead_phones },
  } = useSelector((item) => item.agentProfile.agentProfile);

  const agentInfoState = useSelector((item) => item.agentProfile);

  useEffect(() => {
    if (lead_phones && lead_phones.length) {
      const newArray = lead_phones.map(({ value, type, isPrimary, bad_number, isEditable, id }) => ({
        id,
        value,
        type,
        isPrimary,
        bad_number,
        isEditable,
      }));
      setPhoneNumber(newArray);
    }
  }, [lead_phones]);

  const handleSuccess = () => {
    setErrorAlert({
      errorMsg: "You have successfully updated the phones",
      errorType: "success",
      isOpen: true,
    });
    closeModal();
  };
  const handleError = (error) => {
    setErrorAlert({
      errorMsg: error ? JSON.stringify(error) : "Something went wrong please try later",
      errorType: "error",
      isOpen: true,
    });
  };

  const onSave = () => {
    dispatch(
      setInfoAgentRecruitment({
        schema: { phones: phoneNumber },
        agentId: params?.id,
        handleSuccess,
        handleError,
      })
    );
  };
  return (
    <Fragment>
      <Dialog
        disablePortal
        sx={{ "& .MuiDialog-container": { mt: "30px" } }}
        loading={agentInfoState?.agentInfo?.loading}
        dialogHead={<DialogHead />}
        onSave={onSave}
        buttonWidth="100px"
        dialogBody={
          <DialogBody
            phoneNumber={phoneNumber}
            setPhoneNumberFunc={setPhoneNumberFunc}
            updateNumbersFunc={updateNumbersFunc}
            setPhoneNumber={setPhoneNumber}
            leadPhones={lead_phones}
          />
        }
        dialogFooter={<DialogFooter />}
        state={state}
        maxWidth="md"
        closeModal={closeModal}
      />
      <ResponseAlert
        open={errorAlert.isOpen}
        setOpen={() => setErrorAlert({ errorMsg: "", errorType: "", isOpen: false })}
        alertType={errorAlert.errorType}
        alertMessage={errorAlert.errorMsg}
      />
    </Fragment>
  );
};

// Components
const PhoneNumberForm = ({ phoneNumberLabel, mobileLabel, pnLabel, bnLabel, mb, updateNumbers, id, phoneNumber, setPhoneNumber }) => {
  const changeNumberFunc = (e) => {
    const number = [...phoneNumber];
    const re = new RegExp(/^[0-9\b-]+$/);
    const onlyNumber = number[id].value.replace("-", "");
    if (onlyNumber.length <= 10 && number[id].isEditable && (e.target.value === "" || re.test(e.target.value))) {
      number[id].value = e.target.value;
      setPhoneNumber(number);
    }
  };
  const changeTypeFunc = (e) => {
    const number = [...phoneNumber];
    if (number[id].isEditable) {
      number[id].type = e.target.value;
      setPhoneNumber(number);
    }
  };
  const changePNFunc = (e) => {
    const number = [...phoneNumber];
    number[id].isPrimary = !number[id].isPrimary;
    setPhoneNumber(number);
  };
  const changeBNFunc = (e) => {
    const number = [...phoneNumber];
    number[id].bad_number = !number[id].bad_number;
    setPhoneNumber(number);
  };
  return (
    <Grid container direction="row" alignItems="center" spacing={3} sx={{ flexGrow: 1, marginBottom: mb || 0, overflow: "visible" }}>
      <Grid item sm={5} sx={{ mb: "15px" }}>
        <Input
          size="small"
          onChange={changeNumberFunc}
          value={phoneNumber[id].value}
          label={phoneNumberLabel || false}
          placeholder="1232-324-23232"
        />
      </Grid>
      <Grid item sm={4} sx={{ mb: "15px" }}>
        {mobileLabel ? <InputLabel sx={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.87)", mb: "5px" }}>Label</InputLabel> : null}
        <TextField
          select
          fullWidth
          sx={{ "& .MuiSelect-select ": { padding: "11px 15px" } }}
          onChange={(e) => changeTypeFunc(e)}
          value={phoneNumber[id].type}
          placeholder="Mobile"
        >
          <MenuItem value="mobile">mobile</MenuItem>
          <MenuItem value="work">work</MenuItem>
          <MenuItem value="home">home</MenuItem>
          <MenuItem value="spouse">spouse</MenuItem>
          <MenuItem value="other">other</MenuItem>
        </TextField>
      </Grid>
      <Grid
        item
        sm={1}
        sx={{
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <FormControlLabel
          value="top"
          checked={phoneNumber[id].isPrimary}
          control={<Checkbox />}
          onChange={(e) => changePNFunc(e)}
          label={pnLabel || false}
          labelPlacement="top"
          sx={{ "& .MuiFormControlLabel-label": { textAlign: "center", mt: bnLabel ? "-40px" : "-15px", fontSize: "14px" } }}
        />
      </Grid>
      <Grid
        item
        sm={1}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <FormControlLabel
          value="top"
          control={<Checkbox />}
          label={bnLabel || false}
          labelPlacement="top"
          checked={phoneNumber[id].bad_number}
          sx={{ "& .MuiFormControlLabel-label": { textAlign: "center", mt: bnLabel ? "-40px" : "-15px", fontSize: "14px" } }}
          onChange={(e) => changeBNFunc(e)}
        />
      </Grid>
      <Grid item sm={1} sx={{ textAlign: "center" }}>
        {phoneNumber[id].isEditable ? (
          <IconButton aria-label="delete" sx={{ mt: bnLabel ? "0px" : "-15px" }} onClick={() => updateNumbers(id)}>
            <CancelIcon sx={{ color: "black" }} />
          </IconButton>
        ) : (
          <IconButton sx={{ mt: bnLabel ? "0px" : "-15px" }}>
            <BlockIcon sx={{ color: "black" }} />
          </IconButton>
        )}
      </Grid>
    </Grid>
  );
};

const DialogHead = () => (
  <DialogTitle sx={{ mt: "10px" }}>
    <Typography component="h5" variant="h5">
      Edit Phone Numbers
    </Typography>
  </DialogTitle>
);

const DialogBody = ({ phoneNumber, setPhoneNumberFunc, updateNumbersFunc, setPhoneNumber, leadPhones }) => (
  <DialogContent sx={{ mt: "30px", maxWidth: "800px", overflow: "visible" }}>
    {phoneNumber && phoneNumber.length ? (
      phoneNumber.map((number, index) => {
        if (index === 0) {
          return (
            <PhoneNumberForm
              leadPhones={leadPhones}
              phoneNumberLabel={"Phone Number"}
              mobileLabel="Label"
              pnLabel="Primary Number"
              bnLabel="Bad Number"
              updateNumbers={updateNumbersFunc}
              id={index}
              setPhoneNumber={setPhoneNumber}
              phoneNumber={phoneNumber}
              number={number}
            />
          );
        } else {
          return (
            <>
              <PhoneNumberForm
                leadPhones={leadPhones}
                id={index}
                updateNumbers={updateNumbersFunc}
                setPhoneNumber={setPhoneNumber}
                phoneNumber={phoneNumber}
                number={number}
              />
            </>
          );
        }
      })
    ) : (
      <Typography
        variant="subtitle1"
        component="p"
        sx={{
          display: "block",
          color: "#adadad",
          textAlign: "center",
        }}
      >
        No Phone Numbers Found!
      </Typography>
    )}

    <br />
    <Button
      onClick={() =>
        setPhoneNumberFunc({
          value: "",
          type: "",
          isPrimary: false,
          bad_number: true,
          isEditable: true,
        })
      }
      variant="text"
      themeVersion
      sx={{ textTransform: "capitalize", fontFamily: "AvenirNext-400", mt: "-15px" }}
      startIcon={<AddCircleIcon />}
    >
      Add another phone
    </Button>
  </DialogContent>
);

const DialogFooter = () => (
  <DialogActions>
    <Typography component="p" variant="subtitle1">
      Footer Area
    </Typography>
  </DialogActions>
);
